import z from 'zod';

export const studyContentSchema = z.object({
  content: z.string(),
  title: z.string(),
  graphJson: z.string().optional(),
});

export type StudyContent = z.infer<typeof studyContentSchema>;
